import Swal from 'sweetalert2'

/**
 * House-styled confirm for destructive actions — THE single pattern for
 * "really delete X?" dialogs in the panels. Replaces the previous mix of
 * native confirm(), ElMessageBox.confirm and per-page ad-hoc Swal configs
 * so every delete flow gets the same dark, el-button-styled modal.
 *
 * Resolves to true only when the operator explicitly confirmed.
 */
export type ConfirmDangerSurface = 'panel' | 'storefront'

export async function confirmDanger(
    title: string,
    text: string,
    confirmButtonText = 'Yes, delete it!',
    /**
     * Which surface the dialog opens on.
     *
     *   'panel'      admin / creator / labels. Buttons borrow `el-button`,
     *                which is safe there because those pages render Element
     *                Plus components anyway.
     *   'storefront' the shop. Element Plus styles are auto-imported PER PAGE,
     *                so a shop page that renders no el-* component never loads
     *                the `el-button` CSS — with `buttonsStyling: false` the
     *                buttons would fall back to browser defaults inside a dark
     *                dialog. Let SweetAlert style them instead.
     */
    surface: ConfirmDangerSurface = 'panel'
): Promise<boolean> {
    const storefront = surface === 'storefront'
    const result = await Swal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: 'Cancel',
        background: '#1a1a1a',
        color: '#ffffff',
        buttonsStyling: storefront,
        ...(storefront
            ? { confirmButtonColor: '#e05260', cancelButtonColor: '#3a3a3a' }
            : {
                customClass: {
                    confirmButton: 'el-button el-button--danger',
                    cancelButton: 'el-button'
                }
            })
    })
    return result.isConfirmed
}
